import { isFunction } from "lodash";

import {
  CsvCellTransformerFn,
  CsvCellTransformerFnResponse,
  ICsvColumnTransformer,
} from "./models";
import { useCsvTextCellTransformer } from "./use-csv-text-cell.transformer";
import { operationTransformerFnMap } from "./values-accessors";

export const useCsvDynamicCellTransformer = (): {
  getDynamicTransformerFn: CsvCellTransformerFn;
} => {
  const { getTextValue } = useCsvTextCellTransformer();

  const getDynamicTransformerFn = ({
    controlInfoName,
    ...restProps
  }: ICsvColumnTransformer): CsvCellTransformerFnResponse => {
    if (
      controlInfoName &&
      controlInfoName in operationTransformerFnMap &&
      isFunction(operationTransformerFnMap[controlInfoName])
    ) {
      return operationTransformerFnMap[controlInfoName](restProps);
    }

    return getTextValue(restProps);
  };

  return { getDynamicTransformerFn };
};
